import { render, staticRenderFns } from "./studentReport.vue?vue&type=template&id=0473244c&"
import script from "./studentReport.vue?vue&type=script&lang=js&"
export * from "./studentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports